// Copy and naming for the on-demand quotation result CSV (REQ-420), in one place so the two
// surfaces that offer it — the quotations table row menu and the editor's burger menu — can never
// drift apart.
export const RESULT_CSV_MESSAGES = {
	menuItem: "Download result CSV",
	pending: "Preparing CSV…",
	success: "CSV downloaded",
	// Shown when a save was still travelling when generation started and did not land in time, so the
	// file may be a revision behind. Better than claiming a clean success.
	successMaybeStale: "CSV downloaded, but a recent change may be missing from it.",
	submitted: "This quotation is submitted — its CSV is in the files list.",
	forbidden: "You don't have access to this quotation's CSV.",
	notFound: "This quotation no longer exists.",
	unauthorized: "Your session has expired. Sign in again to download the CSV.",
	failed: "CSV couldn't be generated. Try again.",
	timedOut: "CSV is taking too long. Try again in a moment.",
} as const

// Per-name cap for the composed download name. Two user-entered names plus the joiner have to fit
// inside the ~255-byte limit every common file system enforces, with room for a browser's " (1)"
// de-duplication suffix.
export const RESULT_CSV_NAME_PART_MAX_LENGTH = 80

// How long to let in-flight autosaves finish before generating the CSV. Short: the CSV is worth a
// brief wait, but not a visibly stuck menu.
export const RESULT_CSV_SAVE_FLUSH_TIMEOUT = 5000
